// import Vue from 'vue'
import { createStore } from 'vuex'

import Account from "./modules/account.module"
import Menu    from "./modules/menu.module"
import Common from "./modules/common.module"

// Vue.use(Vuex)

// export default new Vuex.Store({
//   modules: {
//     '$g': Common,
//     account: Account,
//     menu   : Menu
//   }
// })

export default createStore({
  modules: {
    $g: Common,

    account: Account,
    menu   : Menu
  },
})